import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideMenuConfig } from 'ng-primitives/menu';

export function provideMenu(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideMenuConfig({
      placement: 'bottom-start',
      offset: 8,
      flip: true,
      shift: true,
      container: document.body,
      scrollBehavior: 'close',
      triggers: ['click'],
      wrap: true,
      showDelay: 0,
      hideDelay: 0,
      cooldown: 0,
    }),
  ]);
}
